export default __webpack_public_path__ + "static/media/address-icon.f98e7a42.svg";